import constants from "../../Utils/constants";
import useTranslator from "../../hooks/useTranslator";

export const isViviaIdentificationPending = (tenant, ruleEnabled) =>
  ruleEnabled === true &&
  Boolean(tenant) &&
  tenant?.consents?.vivia_consent?.status !== constants.ACCEPTED;

const ViviaIdentificationStatus = () => {
  const { _t } = useTranslator();

  return (
    <span className="vivia-identification-status">
      {_t("amlSigningPending")}
    </span>
  );
};

export default ViviaIdentificationStatus;
